import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { meetTypeAtom, partnerMeetStateAtom, tokenAtom, partnerMeetConfigAtom } from '../../core/config/atoms';

import Lottie from 'lottie-react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ReactStars from "react-rating-stars-component";

import ServiceTicket from 'services/serviceTickets';

import thank from '../../assets/image/thank.png';
import animBtnLoading from '../../assets/anim/anim-btnLoading.json';
import CustomeVideoReview from 'core/widgets/components/CustomeVideoReview';

export default function PanelThankYou({ partner }) {

    const [token] = useRecoilState(tokenAtom);
    const [meetConfig] = useRecoilState(partnerMeetConfigAtom);
    const [, setMeetType] = useRecoilState(meetTypeAtom);
    const [, setMeetState] = useRecoilState(partnerMeetStateAtom);

    const [rating, setRating] = useState(0);

    const [open, setOpen] = useState(false);
    const [submit, setSubmit] = useState(false);

    const navigate = useNavigate();
    const ticketService = new ServiceTicket();

    const formVSchema = Yup.object().shape({});

    const { values, errors, touched, handleChange, handleSubmit, handleReset } = useFormik({
        initialValues: {
            feedback: ''
        },
        enableReinitialze: true,
        validationSchema: formVSchema,
        onSubmit: values => {
            setSubmit(true);
            let body = {
                "tid": meetConfig.roomid,
                "name": meetConfig.name,
                "rating": rating,
                "feedback": values.feedback,
                "type": "customer",
            }
            ticketService.addReviewByRoomId(body, token).then((res) => {
                setSubmit(false);
                navigate('/home/main');
            });
        }
    })

    const gotoBack = () => {
        setMeetType('');
        setMeetState(0);
        navigate('/home/main');
    }

    const ratingChanged = (newRating) => {
        setRating(newRating);
    };

    return (
        <div>
            <CustomeVideoReview open={open} setOpen={setOpen} onSubmit={gotoBack} />
            <div className='h-screen flex flex-col items-center justify-center'>
                <img src={thank} alt='Thank You Image' className='p-8' />
                <div className="relative w-full h-full p-2 rounded">
                    <div className='flex items-center justify-between'>
                        <h3 className="text-xl font-semibold text-gray-900">
                            Submit Review for Interpreter &nbsp;
                        </h3>
                    </div>
                    <hr className='mt-1' />
                    <form className='mt-4' onSubmit={handleSubmit}>
                        <div className="w-full">
                            <div className="flex items-center justify-center">
                                <ReactStars count={5} isHalf={false} onChange={ratingChanged} value={rating} size={54} activeColor="#ffd700" />
                            </div>
                        </div>
                        <div className="w-full mt-4">
                            <div className="">
                                <label className="block text-xs font-medium text-gray-700 font-mono">Feedback</label>
                                <textarea id="feedback" value={values.feedback} onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-20 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. Your feedback"></textarea>
                                {(errors.feedback && touched.feedback) && <p className='text-xs text-red-400 mt-1'>{errors.feedback}</p>}
                            </div>
                        </div>
                        <div className="px-2 py-3 text-right">
                            <button type="button" disabled={submit} className="mr-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-prime hover:bg-primeLight" onClick={() => { setOpen(true); }}>
                                RECORD
                            </button>
                            <button type="submit" disabled={submit} className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-prime hover:bg-primeLight">
                                {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                {!submit && "SUBMIT"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}